import { render } from "./DataAdapterConfiguration.vue?vue&type=template&id=7a92a5a9"
import script from "./DataAdapterConfiguration.vue?vue&type=script&lang=js"
export * from "./DataAdapterConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/data-adapters/DataAdapterConfiguration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a92a5a9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a92a5a9', __exports__)) {
    api.reload('7a92a5a9', __exports__)
  }
  
  module.hot.accept("./DataAdapterConfiguration.vue?vue&type=template&id=7a92a5a9", () => {
    api.rerender('7a92a5a9', render)
  })

}


export default __exports__